export default __webpack_public_path__ + "static/header.stadtmuseumhall.uebersicht-10a0a35c3dbdce0aea6785477fe9db39.png";